<template lang="pug">
.remit-data-icon(v-if="hasRemits")
  button.remit-data-icon__btn(type="button" @click.stop="showModal = true")
    span.material-symbols-outlined(:style="iconStyle") article

  RemitDataModal(:show="showModal" :record="recordData" @close="showModal = false")
</template>

<script>
import RemitDataModal from '@/components/elements/remit/RemitDataModal.vue'
import { latestRemitDiffersFromRecord, recordHasRemit } from '@/helpers/remit'

export default {
  name: 'RemitDataIcon',

  components: { RemitDataModal },

  props: {
    order: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      default: null
    },
    iconColor: {
      type: String,
      default: 'var(--color-placeholder)'
    },
    iconSize: {
      type: String,
      default: '2rem'
    }
  },

  data () {
    return {
      showModal: false
    }
  },

  computed: {
    recordData () {
      return this.record || this.order
    },

    hasRemits () {
      return recordHasRemit(this.recordData)
    },

    isOutdated () {
      return latestRemitDiffersFromRecord(this.recordData)
    },

    iconStyle () {
      return {
        color: this.isOutdated ? 'var(--color-red)' : 'var(--color-font-principal, #363636)',
        fontSize: this.iconSize,
        opacity: 1
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.remit-data-icon__btn
  border none
  background none
  padding 0
  margin 0
  cursor pointer
  display flex
  align-items center
  justify-content flex-start
  -webkit-tap-highlight-color transparent
  touch-action manipulation

  &:active
    opacity .7
</style>



// WEBPACK FOOTER //
// src/components/elements/remit/RemitDataIcon.vue